import api from "./api";
import endpoints from "./endpoints";

export default {
  getMasterData: async function (nodeId, catalogId, languageCode) {
    const response = await api.get(endpoints.catalogNodeTranslation.masterData.get, { params: { nodeId, catalogId, languageCode } });
    return response.data;
  },
  getAttributes: async function (nodeId, catalogId, languageCode) {
    const response = await api.get(endpoints.catalogNodeTranslation.attributes.get, { params: { nodeId, catalogId, languageCode } });
    return response.data;
  },
  getMediaAssets: async function (nodeId, catalogId, languageCode) {
    const response = await api.get(endpoints.catalogNodeTranslation.mediaAsset.get, { params: { nodeId, catalogId, languageCode } });
    return response.data;
  },
  getNameSuggestions: async function (sourceLanguage, targetLanguage, value) {
    const response = await api.get(endpoints.catalogNodeTranslation.suggestions.catalogGroupName.get, { params: { sourceLanguage, targetLanguage, value } });
    return response.data;
  },
  getDescriptionSuggestions: async function (sourceLanguage, targetLanguage, value) {
    const response = await api.get(endpoints.catalogNodeTranslation.suggestions.catalogDescription.get, { params: { sourceLanguage, targetLanguage, value } });
    return response.data;
  },
  getAttributeSuggestions: async function (sourceLanguage, targetLanguage, value) {
    const response = await api.get(endpoints.catalogNodeTranslation.suggestions.catalogAttributes.get, { params: { sourceLanguage, targetLanguage, value } });
    return response.data;
  },
  getMediAssetSuggestions: async function (sourceLanguage, targetLanguage, value) {
    const response = await api.get(endpoints.catalogNodeTranslation.suggestions.catalogMediaAssets.get, { params: { sourceLanguage, targetLanguage, value } });
    return response.data;
  },
  translateAllMasterdata: async function (sourceLanguage, targetLanguage, source, target, onlyEmpty) {
    return api
      .post(
        endpoints.catalogNodeTranslation.translateAllMasterdata.get,
        {
          source,
          target,
          sourceLanguage,
          targetLanguage
        },
        { params: { onlyEmptyValues: onlyEmpty } }
      )
      .then((x) => Promise.resolve(x.data));
  },
  translateAllAttributes: async function (sourceLanguage, targetLanguage, source, target, onlyEmpty) {
    return api
      .post(
        endpoints.catalogNodeTranslation.translateAllAttributes.get,
        {
          source,
          target,
          sourceLanguage,
          targetLanguage
        },
        { params: { onlyEmptyValues: onlyEmpty } }
      )
      .then((x) => Promise.resolve(x.data));
  },
  translateAllMediaAssets: async function (sourceLanguage, targetLanguage, source, target, onlyEmpty) {
    return api
      .post(
        endpoints.catalogNodeTranslation.translateAllMediaAssets.get,
        {
          source,
          target,
          sourceLanguage,
          targetLanguage
        },
        { params: { onlyEmptyValues: onlyEmpty } }
      )
      .then((x) => Promise.resolve(x.data));
  },
  updateMasterdata: async function (language, model) {
    return api
      .post(endpoints.catalogNodeTranslation.masterData.update, model, {
        params: { language }
      })
      .then((x) => Promise.resolve(x.data));
  },
  updateAttributeData: async function (language, model) {
    return api
      .post(endpoints.catalogNodeTranslation.attributes.update, model, {
        params: { language }
      })
      .then((x) => Promise.resolve(x.data));
  },
  updateMediaAssets: async function (language, model) {
    return api
      .post(endpoints.catalogNodeTranslation.mediaAsset.update, model, {
        params: { language }
      })
      .then((x) => Promise.resolve(x.data));
  }
};
